import { OrderDataService } from "../../data-service/order-data.service";
import { ProductDocumentInterface } from "../../interface/motor-quotation.interface";
import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {
	productId: string;
	code: string;
	lang: string;
	insuranceType: string;
}
@Component({
	selector: "app-benefit-dialog",
	templateUrl: "./benefit-dialog.component.html",
	styleUrls: ["./benefit-dialog.component.scss"],
})
export class BenefitDialogComponent {
	productDocumentInterface: ProductDocumentInterface[] = [];

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: DialogData,
		private orderDataService: OrderDataService,
	) {
		this.getProductDocument();
	}

	private getProductDocument() {
		if (!this.data) return;
		this.orderDataService
			.getProductDocumentById(
				this.data.productId,
				this.data.lang,
				this.data.insuranceType,
			)
			.subscribe({
				next: (x) => {
					this.productDocumentInterface = x;
				},
			});
	}
}
